import { FormControl, FormGroup, Grid, Switch, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { Box } from '@mui/system';
import { Link } from 'react-router-dom';
import { Grupo } from '../../types/grupo/Grupo';
import configUrls from '../../config/configUrls';
import { TipoDocumento } from '../../types/tipoDocumento/TipoDocumento';
import ReactQuill from 'react-quill';
import { useRef } from 'react';




type Props = {
    data: TipoDocumento,
    isdisabled?: boolean,
    isLoading?: boolean,
    handleSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
    handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleCorpoChangeQuill?: (value: string) => void;
}

export function TipoDocumentoForm({
    data,
    isdisabled = false,
    isLoading = false,
    handleSubmit,
    handleChange,
    handleCorpoChangeQuill
}: Props) {


    const quillRef = useRef<ReactQuill | null>(null); // Especifica que pode ser null
   /* const handleCorpoChangeQuill = (value: string) => {
        // Atualiza o corpo do conteúdo com o valor do editor
        // if (handleChange) {
        //     handleChange({ target: { name: 'conteudo', value } } as React.ChangeEvent<HTMLInputElement>);
        // }

        console.log("REact quill value", value);
    };*/

    return (
        <Box mt={2} p={2}>

            <form onSubmit={handleSubmit} method='POST'>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                required
                                label="Nome"
                                name="nome"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                inputProps={{ maxLength: 255 }}
                                value={data.nome} />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                required
                                label="Abreviatura"
                                name="abreviatura"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                inputProps={{ maxLength: 255 }}
                                value={data.abreviatura} />
                        </FormControl>
                    </Grid>



                    <Grid item xs={12}>
                        <FormControl fullWidth>

                            <ReactQuill
                                ref={quillRef}
                                value={data.conteudo ? data.conteudo : ""}
                                onChange={handleCorpoChangeQuill}
                                modules={{
                                    toolbar: [
                                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                        ['bold', 'italic', 'underline', 'strike'],
                                        ['blockquote', 'code-block'],
                                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                        [{ 'script': 'sub' }, { 'script': 'super' }],
                                        [{ 'indent': '-1' }, { 'indent': '+1' }],
                                        [{ 'direction': 'rtl' }],
                                        [{ 'color': [] }, { 'background': [] }],
                                        [{ 'align': [] }],
                                        ['link', 'image', 'video'],
                                        ['clean'],
                                        ['emoji'],
                                        ['table'],
                                        ['audio'],
                                        [{ size: ['small', false, 'large', 'huge'] }]
                                    ]
                                }}
                                placeholder="Escreva a publicação aqui..."
                            />


                        </FormControl>

                    </Grid>

                    <Grid item xs={12}>
                        <Box display="flex" gap={2}>

                            <Button
                                type="submit"
                                variant="contained"
                                color="secondary"
                                disabled={isdisabled}
                            >
                                Gravar
                            </Button>

                            <Button
                                variant="contained"
                                component={Link}
                                to={configUrls.TIPO_DOCUMENTO_LIST_RT}
                            >
                                Voltar
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}